export function drawGeoJsonRoute(map, geojson, options = {}) {
  if (!map || !geojson) return;

  //If route length is less than 5 points we don't draw it as its broken.

  if (geojson.geometry.coordinates.length < 5) return;

  const colorPresets = { bike: '#E16B0C', public: '#0082B8', walk: '#1B7E41' };
  const color = options.color || colorPresets[options.routeType] || '#0082B8';
  const width = options.width ?? 3;
  const opacity = options.opacity ?? 1;

  // default per-mode offsets (pixels). bike central, bus right, walk left.
  const modeOffsets = { public: 3, bike: 0, walk: -3 };

  const baseOffset = modeOffsets[options.routeType] ?? 0;

  // scale offset with zoom: smaller at low zoom, larger when zoomed in
  const zoomScaledOffset = [
    'interpolate',
    ['linear'],
    ['zoom'],
    10,
    baseOffset * 0.4,
    14,
    baseOffset * 0.8,
    17,
    baseOffset * 1.2,
  ];

  const uniqueId = `route-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  const sourceId = `${uniqueId}-source`;
  const layerId = `${uniqueId}-layer`;

  map.addSource(sourceId, { type: 'geojson', data: geojson });

  map.addLayer({
    id: layerId,
    type: 'line',
    source: sourceId,
    layout: { 'line-join': 'round', 'line-cap': 'round' },
    paint: {
      'line-color': color,
      'line-width': width,
      'line-opacity': opacity,
      'line-offset': zoomScaledOffset,
    },
  });

  const remove = () => {
    if (map.getLayer(layerId)) map.removeLayer(layerId);
    if (map.getSource(sourceId)) map.removeSource(sourceId);
  };

  return { sourceId, layerId, remove };
}
